// Main App Component

import React from 'react';
import { AppRoutes } from './Routes';
import "./App.css";

function App() {
  return (
    // Load AppRoutes from Routes.js
    <AppRoutes />
  )
}

export default App